import { render, staticRenderFns } from "./FilmBoard.vue?vue&type=template&id=00c2592e&scoped=true&"
import script from "./FilmBoard.vue?vue&type=script&lang=js&"
export * from "./FilmBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c2592e",
  null
  
)

export default component.exports